<template>
<div>
    <div class="page-body">
        <div class="content">
            <el-table :data="listData" @selection-change="handleSelectionChange" v-loading="false" style="width: 100%" >
                <el-table-column type="selection" width="55">
                </el-table-column>
                <el-table-column label="内容" prop="message"></el-table-column>
                <el-table-column label="姓名" prop="name" width="120"></el-table-column>
                <el-table-column label="联系电话" prop="cellphone" width="180"></el-table-column>
                <el-table-column label="留言时间"  width="120">
                    <template slot-scope="scope">
                        {{ scope.row.createdAt | filterDate() }}
                    </template>
                </el-table-column>
                <el-table-column label="留言对象" width="120">
                    <template slot-scope="scope">
                        {{ scope.row | filterObject() }}
                    </template>
                </el-table-column>
                <el-table-column label="状态" width="90">
                    <template slot-scope="scope">
                        {{ scope.row.status | filterStatus() }}
                    </template>
                </el-table-column>
                <el-table-column align="left" width="180" label="操作">
                    <template slot-scope="scope">
                        <el-button type="warning" @click="goHandle(scope.row)" :disabled="scope.row.status==2" size="mini">已处理</el-button>
                        <el-button type="danger" @click="deleteDTO([scope.row.id])" size="mini">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination @current-change="handleCurrentChange" :current-page.sync="params.basePage.no" :page-size="params.basePage.size" layout="total, prev, pager, next" :total="totalElements" :background="false" :hide-on-single-page="true">
                </el-pagination>
            </div>
        </div>

    </div>
</div>
</template>

<script>
import {
    getLeaveMessageListByCondition,
    delLeaveMessage,
    updateMessageStatus,
} from '@/api/jingshi';
export default {
    components: {},
    data() {
        return {
            loading: false,
            listData: [],
            ids:[],//批量操作ids
            totalElements: 0, //总条数
            params: {
                keyword: '', // 关键词
                status: 0, // 处理状态 1待处理 2已处理
                type:1,//1律师团队 2律师 3业务平台
                basePage: {
                    size: 12, // 分页大小
                    no: 1, // 当前分页
                }
            }
        }
    },
    filters: {
        filterStatus: function (e) {
            var transMap = {
                1: '待处理',
                2: '已处理',
            };
            return transMap[e];
        },
        filterObject: function (e) {
            if(e.lawyer){
                return e.lawyer;
            }
            if(!e.lawyer&&e.team){
                return e.team;
            }
            return '平台消息';
        },
        filterDate: function (e) {
            console.log(e);
            return e.substring(0,10);
        },
        
    },
    methods: {
        search(params) {
            if (params) {
                for (let key in this.params) {
                    if (params.hasOwnProperty(key)) {
                        this.params[key] = params[key];
                    }
                }
            }
            this.getList();
        },
        // 获取列表
        getList() {
            var vues = this;
            this.loading = true;
            getLeaveMessageListByCondition(this.params).then(res => {
                this.listData = res.leaveMessageList
                this.totalElements = res.totalElements;
                // console.log(res);
                vues.loading = false;
            })
        },
        // 删除
        deleteDTO(ids) {
            var param = {
                ids: ids
            }
            delLeaveMessage(param).then(res => {
                this.$message.success('操作成功!')
                this.getList()
            }).catch(err => {
                console.log(err);
            })
        },
        // 编辑 
        goHandle: function (e) { 
             var param = {
                id: e.id,
                status:2,
            }
            updateMessageStatus(param).then(res => {
                this.$message.success('操作成功!')
                this.getList()
            }).catch(err => {
                console.log(err);
            })
        },
        handleSelectionChange(e){
            console.log(e);
            this.ids=[];
            for(var i=0;i<e.length;i++){
                this.ids.push(e[i].id);
            }
        },
        ids(){
            return this.ids;
        },
        handleCurrentChange(val) {
            this.params.basePage.no=val;
            this.getList();
        },
    },
    created: function () {
        this.getList()
    }
}
</script>

<style lang="scss">
.page-body {
    padding: 20px;

    .content {
        width: 100%;
        background: white;
        .pagination{
            text-align:center;
        }
    }
}

.page-body table {
    width: 100%;
}

.page-body .content {
    width: 100%;
    background: white;
}

 // 头部样式

.page-body th {
    background-color: #efefef;
}

// .el-input__suffix {
//   right: 0px;
//   transition: all 0.3s;
// }
</style>



// WEBPACK FOOTER //
// list.vue?aa759302